import { render, staticRenderFns } from "./RibbonTitle.vue?vue&type=template&id=a5fa88e6&scoped=true&"
import script from "./RibbonTitle.vue?vue&type=script&lang=js&"
export * from "./RibbonTitle.vue?vue&type=script&lang=js&"
import style0 from "./RibbonTitle.vue?vue&type=style&index=0&id=a5fa88e6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5fa88e6",
  null
  
)

export default component.exports